import * as React from 'react';
import {
  List,
  ListSubheader,
  ListItemButton,
  ListItemText,
  Grid,
  Box,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import { v4 as uuidv4 } from 'uuid'; // Assuming you have the 'uuid' library instal
import { SiteColor } from './constants';
import CustomIcon from '@mui/icons-material/DashboardCustomize';
import { InnerItemList } from './InnerItemList';
import  ReportViewer from './reportdocument';

function getScreenSize() {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  const result = 
   viewportWidth <= 468 ? 'S' : viewportWidth <= 768 ? 'M' : 'L' ; // Adjust breakpoint as needed
  console.log('Screen Size:', result);
   return result;
}

function debounce(func, delay) {
  let timeout;

  return function() {
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}


export default function GeneralGrid({title, dispatch , inputItems = []}) {
  const screenSize = getScreenSize();

  const [totalKiloWattHours, setTotalKiloWattHours] = React.useState([]);
  const [openResetDialog, setOpenResetDialog] = React.useState(false);

  const [selectedGeneralItems, setSelectedGeneralItems] = React.useState([]);
  const [selectedKitchenItems, setSelectedKitchenItems] = React.useState([]);
  const [selectedLaundryItems, setSelectedLaundryItems] = React.useState([]);
  const [selectedTechItems, setSelectedTechItems] = React.useState([]);
  const [selectedPowertoolsItems, setSelectedPowertoolsItems] = React.useState([]);
  const [customItems, setCustomItems] = React.useState([]);

  const [potentialLoadKW, setPotentialLoadKW] = React.useState(0.00);
  const [averageKWhPerDay, setAverageKWhPerDay] = React.useState(0.00);
  const [usePercent, setUsePercent] = React.useState(50.00);
  const [daysOfReservePower, setDaysOfReservePower] = React.useState(3);
  const [winterAvgDailyEffectiveSolar, setWinterAvgDailyEffectiveSolar] = React.useState(2);
  const [requireThreePhase, setRequireThreePhase] = React.useState(false);

  const [solarArraySize, setSolarArraySize] = React.useState(0.00);
  const [batteryStorageSize, setBatteryStorageSize] = React.useState(0.00);
  const [inverterSize, setInverterSize] = React.useState(0.00);

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [company, setCompany] = React.useState('');
  const [message, setMessage] = React.useState(null);
  const [messageState, setMessageState] = React.useState('hide');


  function updateTotal() {
    let total = 0.00;
    const allItems = [...selectedGeneralItems, ...selectedKitchenItems, ...selectedLaundryItems, ...selectedTechItems, ...selectedPowertoolsItems, ...customItems];
    allItems.forEach(element => {
      total += (element.runningWatts * element.quantity * element.hoursPerDay) / 1000;
    });

    return total;
    
  }

  function updateTotalKW() {
    let total = 0.00;
    const allItems = [...selectedGeneralItems, ...selectedKitchenItems, ...selectedLaundryItems, ...selectedTechItems, ...selectedPowertoolsItems, ...customItems];
    allItems.forEach(element => {
      total += (element.runningWatts * element.quantity) / 1000;
    });

    return total;
    
  }

  React.useEffect(() => { // Update selected items when items changes

    if(inputItems)
    {
      if(inputItems.selectedGeneralItems)
      setSelectedGeneralItems([...inputItems.selectedGeneralItems]);

      if(inputItems.selectedKitchenItems)
      setSelectedKitchenItems([...inputItems.selectedKitchenItems]);

      if(inputItems.selectedLaundryItems)
      setSelectedLaundryItems([...inputItems.selectedLaundryItems]);

      if(inputItems.selectedTechItems)
      setSelectedTechItems([...inputItems.selectedTechItems]);
    
      if(inputItems.selectedPowertoolsItems)
      setSelectedPowertoolsItems([...inputItems.selectedPowertoolsItems]);

      if(inputItems.customItems)
      setCustomItems([...inputItems.customItems]);
    }
  },[inputItems]);



  React.useEffect(() => { // Update selected items when items changes
    const total = updateTotal();
    setTotalKiloWattHours(total.toFixed(2));

    const potentialLoadKW = updateTotalKW();
    setPotentialLoadKW(potentialLoadKW.toFixed(2));

    setAverageKWhPerDay(total.toFixed(2));

  }, [customItems, selectedGeneralItems, selectedKitchenItems, selectedLaundryItems, selectedTechItems, selectedPowertoolsItems]);

  React.useEffect(() => {

    if (firstName && lastName && (email || phone)) {

      if (email) {
        if (!validateEmail(email)) {
          setMessageState('email-error');
        } else {
          setMessageState('email');
        }
      }
      else if (phone) {
        setMessageState('phone');
      }

    }else
    if (company && (email || phone)) {
      setMessageState('email');
    }else
    {
      setMessage(null);
      setMessageState('hide');
    }

  }, [firstName, lastName, email, phone, company]);
  
  var validateEmail = function (email) {
    var re = /^\S+@\S+(?:\.\S+)+$/;
    const res = re.test(email);
    return re.test(email);
  };


  const doCalculateClick = () => {

    console.log(totalKiloWattHours);
     const solarArraySize = (averageKWhPerDay / winterAvgDailyEffectiveSolar).toFixed(2);
     setSolarArraySize(solarArraySize);

     //avekwh per day.
     const batteryStorageSize = (averageKWhPerDay * daysOfReservePower).toFixed(2);
     setBatteryStorageSize(batteryStorageSize);

     //Running watts as a factor of useAppiancies.
     const inverterSize = (potentialLoadKW * (usePercent/100)).toFixed(2);
      setInverterSize(inverterSize);
   };

  const doAddCustomClick = () => {
   // dispatch({type:"reset_all"})
    const nextNuber = customItems.length + 1;
   //Add an item to customItems
    const newItem = { id: uuidv4(), icon: <CustomIcon />, primary: `Custom ${nextNuber}`, quantity: 1, runningWatts: 1, hoursPerDay: 1, isSelected: false};
    dispatch({type:'set_custom', payload : [...customItems, newItem]})
    setCustomItems((prevItems) => [...prevItems, newItem]);
  };

  const handleQtyChange = (f, item, value, name) => {
    f((prevItems) => {
      const updatedItems = [...prevItems];
      const index = updatedItems.findIndex((i) => i === item); // Find the index of the item to update
      updatedItems[index].quantity = value; // Update the quantity 
      dispatch({type:name, payload : [...updatedItems]})
      return [...updatedItems]; // Return the updated array
    }); 
  };

  const handleWattsChange = (f,item, value , name) => {
    f((prevItems) => {
      const updatedItems = [...prevItems];
      const index = updatedItems.findIndex((i) => i === item); // Find the index of the item to update
      updatedItems[index].runningWatts = value; // Update the quantity property
      dispatch({type:name, payload : [...updatedItems]})
      return [...updatedItems]; // Return the updated array
    });
  };

  const handleHoursChange = (f,item, value , name) => {
    f((prevItems) => {
      const updatedItems = [...prevItems];
      const index = updatedItems.findIndex((i) => i === item); // Find the index of the item to update
      updatedItems[index].hoursPerDay = value; // Update the quantity property
      dispatch({type:name, payload : [...updatedItems]})
      return [...updatedItems]; // Return the updated array
    });
  };

  const handleDeleteClick = (f,item , name) => {
    console.log('Clicked delete:', item);
    f((prevItems) => {
      const updatedItems = [...prevItems];
      const index = updatedItems.findIndex((i) => i === item); // Find the index of the item to update
      updatedItems.splice(index, 1); // Remove the item from the array
      dispatch({type:name, payload : [...updatedItems]})
      return [...updatedItems]; // Return the updated array

    });

};

  return (


    <Grid key={title} sx={{ minWidth: 400 , margin:'auto'}}>
    <List
      sx={{margin : 2,  bgcolor: 'background.paper', border: '2px solid #ccc', borderRadius: 4 }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader component="div" id="nested-list-subheader"  sx={{marginTop:2,  fontSize: 32,  color: SiteColor }}>
          {totalKiloWattHours > 0 ?    `${title} - ${totalKiloWattHours} kWh` : title}
        </ListSubheader>
      }
    >

      <Grid item xs={12}>
          <Grid item justifyContent="center" alignContent="center">
            <ListItemButton onClick={() => doAddCustomClick()} // Add onClick handler
             sx={{ border: '1px solid #ccc', borderRadius: 4, fontSize:16, ml: 2, mr: 2 }}>
              <Grid container direction="column" alignItems="center">
                <ListItemText primary={`Add Custom Appliance`} />
              </Grid>
            </ListItemButton>
          </Grid>
      </Grid> 

      <Grid   container alignItems="center" spacing={2} padding={2}>
      <InnerItemList items={customItems} screenSize={screenSize} 
       handleDeleteClick={(item) => handleDeleteClick(setCustomItems, item,"set_custom" )} 
       handleHoursChange={(item,vale) => handleHoursChange(setCustomItems, item,vale,"set_custom" )} 
       handleQtyChange={(item,vale) => handleQtyChange(setCustomItems, item,vale,"set_custom" )} 
       handleWattsChange={(item,vale) => handleWattsChange(setCustomItems, item,vale,"set_custom" )}  />
       <InnerItemList items={selectedGeneralItems} screenSize={screenSize}  
      handleDeleteClick={(item) => handleDeleteClick(setSelectedGeneralItems, item,"set_household" )} 
       handleHoursChange={(item,vale) => handleHoursChange(setSelectedGeneralItems, item,vale,"set_household" )} 
       handleQtyChange={(item,vale) => handleQtyChange(setSelectedGeneralItems, item,vale,"set_household" )} 
       handleWattsChange={(item,vale) => handleWattsChange(setSelectedGeneralItems, item,vale,"set_household" )}  />
       <InnerItemList items={selectedKitchenItems} screenSize={screenSize}  
       handleDeleteClick={(item) => handleDeleteClick(setSelectedKitchenItems, item,"set_kitchen" )} 
       handleHoursChange={(item,vale) => handleHoursChange(setSelectedKitchenItems, item,vale,"set_kitchen" )} 
       handleQtyChange={(item,vale) => handleQtyChange(setSelectedKitchenItems, item,vale,"set_kitchen" )} 
       handleWattsChange={(item,vale) => handleWattsChange(setSelectedKitchenItems, item,vale,"set_kitchen" )}  />
       <InnerItemList items={selectedLaundryItems} screenSize={screenSize}  
       handleDeleteClick={(item) => handleDeleteClick(setSelectedLaundryItems, item,"set_laundry" )} 
       handleHoursChange={(item,vale) => handleHoursChange(setSelectedLaundryItems, item,vale,"set_laundry" )} 
       handleQtyChange={(item,vale) => handleQtyChange(setSelectedLaundryItems, item,vale ,"set_laundry" )} 
       handleWattsChange={(item,vale) => handleWattsChange(setSelectedLaundryItems, item,vale,"set_laundry" )}  />
       <InnerItemList items={selectedTechItems} screenSize={screenSize}  
       handleDeleteClick={(item) => handleDeleteClick(setSelectedTechItems, item,"set_tech" )} 
       handleHoursChange={(item,vale) => handleHoursChange(setSelectedTechItems, item,vale,"set_tech" )} 
       handleQtyChange={(item,vale) => handleQtyChange(setSelectedTechItems, item,vale ,"set_tech" )} 
       handleWattsChange={(item,vale) => handleWattsChange(setSelectedTechItems, item,vale,"set_tech" )}  />
       <InnerItemList items={selectedPowertoolsItems} screenSize={screenSize} 
       handleDeleteClick={(item) => handleDeleteClick(setSelectedPowertoolsItems, item,"set_power" )} 
       handleHoursChange={(item,vale) => handleHoursChange(setSelectedPowertoolsItems, item,vale,"set_power" )} 
       handleQtyChange={(item,vale) => handleQtyChange(setSelectedPowertoolsItems, item,vale,"set_power" )} 
       handleWattsChange={(item,vale) => handleWattsChange(setSelectedPowertoolsItems, item,vale,"set_power" )}  />

     



        <Grid container direction="row" pl  ={5} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
        <ListItemText sx={{maxWidth : '70%' }} secondary={'Potential Load KW'} />
                           <TextField
                           variant="filled"
                      value={potentialLoadKW} // Bind value to item's property
                      sx={{fontSize : '10', width : '25%',  mt: 2 }} // Add margin for spacing
                    />
        </Grid>

        <Grid container direction="row" pl={5} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
        <ListItemText sx={{maxWidth : '70%' }} secondary={'Average Daily KWh'} />
                           <TextField  variant="filled"
                      value={averageKWhPerDay} // Bind value to item's property
                      sx={{fontSize : '10', width : '25%',  mt: 2 }} // Add margin for spacing
                    />
        </Grid>
        
        <Grid container direction="row" pl={5} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
        <ListItemText sx={{maxWidth : '70%'  }} secondary={'Percentage of appliances used at the same time'} />
                           <TextField  
                           onChange={(e) => setUsePercent(e.target.value)}
                      value={usePercent} // Bind value to item's property
                      sx={{fontSize : '10', width : '25%',  mt: 2 }} // Add margin for spacing
                    /> 
        </Grid>

        <Grid container direction="row" pl={5} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
        <ListItemText sx={{maxWidth : '70%' }} secondary={'Days of Reserve Power'} />
                           <TextField
                           onChange={(e) => setDaysOfReservePower(e.target.value)}
                      value={daysOfReservePower} // Bind value to item's property
                      sx={{fontSize : '10', width : '25%',  mt: 2 }} // Add margin for spacing
                    />
        </Grid>

        <Grid container direction="row" pl={5} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
        <ListItemText sx={{maxWidth : '70%' }} secondary={'Winter Avgerage Daily Effective Solar'} />
                           <TextField  
                           onChange={(e) => setWinterAvgDailyEffectiveSolar(e.target.value)}
                      value={winterAvgDailyEffectiveSolar} // Bind value to item's property
                      sx={{fontSize : '10', width : '25%',  mt: 2 }} // Add margin for spacing
                    />
        </Grid>

        <Grid container direction="row" pl={5} textAlign='start' alignItems="baseline" justifyItems={'flex-start'} >
        <ListItemText sx={{maxWidth : '70%' }} secondary={'Require Three Phase'} />
                           <Checkbox
                            onChange={(e) => setRequireThreePhase(e.target.value)}
                      value={requireThreePhase} // Bind value to item's property
                      sx={{fontSize : '10', width : '25%',  mt: 2 }} // Add margin for spacing
                    />
        </Grid>

        {solarArraySize == 0.00 ? 
        <Grid item xs={12}>
          <Grid item justifyContent="center" alignContent="center">
            <ListItemButton onClick={() => doCalculateClick()} // Add onClick handler
             sx={{ border: '1px solid #ccc', borderRadius: 4, fontSize:16, color:'ButtonHighlight', backgroundColor: 'hsla( 150,94.93670886075948%,30.980392156862745% ,1)' }}>
              <Grid container direction="column" alignItems="center">
                <ListItemText primary={`Calculate`} />
              </Grid>
            </ListItemButton>
          </Grid>

          </Grid> : 
          <></>
          }

        { solarArraySize == 0.00 ? <></> : 
        <Grid container direction="row">
                  <Grid container direction="row" pl  ={5} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
        <ListItemText sx={{maxWidth : '70%' }} primary={'Solar Array Size'} />
                           <TextField
                           
                           variant="filled"
                      value={solarArraySize} // Bind value to item's property
                      sx={{fontSize : '10', width : '25%',  mt: 2 }} // Add margin for spacing
                    />
        </Grid>
        
          <Grid container direction="row" pl  ={5} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
          <ListItemText sx={{maxWidth : '70%' }} primary={'Battery Storage Size'} />
                            <TextField
                            variant="filled"
                        value={batteryStorageSize} // Bind value to item's property
                        sx={{fontSize : '10', width : '25%',  mt: 2 }} // Add margin for spacing
                      />
          </Grid>

          <Grid container direction="row" pl  ={5} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
          <ListItemText sx={{maxWidth : '70%' }} primary={'Inverter Size'} />
                            <TextField
                            variant="filled"
                        value={inverterSize} // Bind value to item's property
                        sx={{fontSize : '10', width : '25%',  mt: 2 }} // Add margin for spacing
                      />
          </Grid>



        </Grid>
         }



          { solarArraySize == 0.00 ? <></> : 
            <Grid item xs={12}>
              <Grid item  justifyContent="center" alignContent="center">
                <div className="Final-header"> 
                <div style={{marginLeft: 5, marginRight: 5}}><h4>3. Provide your details to get a complimentary system design</h4></div>        
                  <div style={{marginLeft: 5, marginRight: 5}}>Establishing a load profile is the first step in sizing up an Off Grid system.</div>
                </div>
                </Grid>

              <Grid container direction="row" pl  ={3} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
        
                                <TextField
                                 label="First name"
                                  inputMode='text'
                                 
                                onChange={(e) => setFirstName(e.target.value)}
                            value={firstName} // Bind value to item's property
                            sx={{fontSize : '10', width : '100%',  mt: 2, mr: 3 }} // Add margin for spacing
                          />
              </Grid>

              <Grid container direction="row" pl  ={3} textAlign='start' alignItems="baseline" justifyItems={'baseline'}>
 
                                <TextField
                                 label="Last name"
                                inputMode='text'
                               onChange={(e) => setLastName(e.target.value)}
                            value={lastName} // Bind value to item's property
                            sx={{fontSize : '10', width : '100%',  mt: 2,mr: 3}} // Add margin for spacing
                          />
              </Grid>

              <Grid container direction="row" pl  ={3} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>

                                <TextField
                                label="Company"
                                inputMode='text'
                               onChange={(e) => setCompany(e.target.value)}
                            value={company} // Bind value to item's property
                            sx={{fontSize : '10', width : '100%',  mt: 2,mr: 3}} // Add margin for spacing
                          />
              </Grid>

              <Grid container direction="row" pl  ={3} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
            
                                <TextField
                                  label="Email"
                                  inputMode='email'
                                  error={messageState === 'email-error' ? true : false}
                               onChange={(e) => setEmail(e.target.value)}
                            value={email} // Bind value to item's property
                            sx={{fontSize : '10', width : '100%',  mt: 2,mr: 3 }} // Add margin for spacing
                          />
              </Grid>

              <Grid container direction="row" pl  ={3} textAlign='start' alignItems="baseline" justifyItems={'flex-start'}>
                                <TextField
                                  label="Phone"
                                inputMode='tel'
                                 onChange={(e) => setPhone(e.target.value)}
                            value={phone} // Bind value to item's property
                            sx={{fontSize : '10', width : '100%',  mt: 2,mr: 3}} // Add margin for spacing
                          />
              </Grid>
              {messageState == 'hide' ? <></> :
              <Grid container direction="column" marginTop={5}  alignItems="center" justifyItems={'center'}>
                <ReportViewer 
                potentialLoadKW={potentialLoadKW} 
                averageKWhPerDay={averageKWhPerDay} 
                usePercent={usePercent} 
                daysOfReservePower={daysOfReservePower}
                winterAvgDailyEffectiveSolar={winterAvgDailyEffectiveSolar}
                requireThreePhase={requireThreePhase}
                solarArraySize={solarArraySize}
                batteryStorageSize={batteryStorageSize}
                inverterSize={inverterSize}
                items={[...selectedGeneralItems, ...selectedKitchenItems, ...selectedLaundryItems, ...selectedTechItems, ...selectedPowertoolsItems, ...customItems]}
                firstName={firstName}
                lastName={lastName}
                email={email}
                phone={phone}
                company={company}
                ></ReportViewer>
              </Grid>}
            </Grid>   
          } 

      </Grid>
    </List>
    </Grid>
  );


}
